<template>
  <v-app>
    <AppNavDrawer v-if="authStore.isAuthenticated" v-model="drawer" />

    <v-app-bar color="primary">
      <v-app-bar-nav-icon
        v-if="authStore.isAuthenticated"
        :aria-label="$t('common.menu')"
        @click="drawer = !drawer"
      />
      <v-app-bar-title style="cursor: pointer" @click="$router.push('/')">
        {{ authStore.appName }}
      </v-app-bar-title>

      <v-spacer />

      <v-btn icon :title="$t('common.toggleTheme')" @click="toggleTheme">
        <v-icon>{{ themeIcon }}</v-icon>
      </v-btn>
      <v-btn icon :title="$t('common.toggleLanguage')" @click="toggleLanguage">
        <v-icon>mdi-translate</v-icon>
      </v-btn>

      <v-btn v-if="!authStore.isAuthenticated" variant="text" @click="$router.push('/login')">
        {{ $t('auth.login') }}
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <AppSnackbar />
  </v-app>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useTheme } from 'vuetify'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/store/auth'
import AppSnackbar from '@/components/AppSnackbar.vue'
import AppNavDrawer from '@/components/AppNavDrawer.vue'
import { useNavDrawer } from '@/composables/useNavDrawer'

const theme = useTheme()
const { locale } = useI18n()
const authStore = useAuthStore()
const { drawer } = useNavDrawer()

const themeIcon = computed(() =>
  theme.global.name.value === 'dark' ? 'mdi-brightness-7' : 'mdi-brightness-4',
)

function toggleTheme() {
  theme.global.name.value = theme.global.name.value === 'dark' ? 'light' : 'dark'
}

function toggleLanguage() {
  locale.value = locale.value === 'en' ? 'de' : 'en'
}

onMounted(() => authStore.checkAuthConfig())
</script>
